import {createActionGroup, emptyProps, props} from '@ngrx/store';
import {Service} from "../../models/service.model";

export const ServicesChannelActions = createActionGroup({
  source: '[Service/Channel]',
  events: {
    subscribe: emptyProps(),
    subscribePartial: emptyProps(),
    unsubscribe: emptyProps(),
    unsubscribeSuccess: emptyProps(),
    notificationReceived: props<{ notification: Service }>(),
    partialNotificationReceived: props<{ notification: Service }>(),
  }
});

export const ServicesAPiActions = createActionGroup({
  source: '[Service/API]',
  events: {

    //Get infinite scroll services
    getInfiniteScrollServices: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollServicesSuccess: props<{ services: Service[], cursor?: string, isSubscribeToChannel?: boolean }>(),
    getInfiniteScrollServicesFailure: props<{ error: any }>(),

    //Get services
    getServices: props<{ params?: any, isSubscribeToChannel?: boolean }>(),
    getServicesSuccess: props<{ services: Service[], isSubscribeToChannel?: boolean }>(),
    getServicesFailure: props<{ error: any }>(),

    //Get services for map in batches
    getMapServicesInBatches: props<{
      params?: any,
      isSubscribeToChannel?: boolean,
      batchSize?: number,
      maxItems?: number,
      intervalMs?: number
    }>(),
    getMapServicesInBatchesFailure: props<{ error: any }>(),

    //Get service
    getService: props<{ serviceId: string, isSubscribeToChannel?: boolean }>(),
    getServiceSuccess: props<{ service: Service, isSubscribeToChannel?: boolean }>(),
    getServiceFailure: props<{ error: any }>()

  },
});

export const ServicesActions = createActionGroup({
  source: '[Service]',
  events: {
    removeServices: props<{ ids: string[] }>(),
    removeService: props<{ id: string }>(),
    setServices: props<{ services: Service[], isAppendFirst?: boolean }>(),
    setInfiniteScrollServiceIds: props<{ serviceIds: string[], isAppendFirst?: boolean }>(),
    setService: props<{ services: Service[], isAppendFirst?: boolean }>(),
    updateService: props<{ service: Service }>(),
    updateServices: props<{ services: Service[] }>(),
    removeAll: emptyProps(),
    clearStore: emptyProps()
  }
});
